import {Typography} from '@viptech/react-components'
import React, {useEffect, useState} from 'react'
import imageErrorIcon from 'src/images/imageErrorIcon.svg'

type Props = {
  src: string
  showErrorText?: boolean
  width: string
  height: string
  alt?: string
} & React.HTMLAttributes<HTMLImageElement>

export default function PhotoCard({showErrorText: showText = true, onMouseEnter, onMouseLeave, children, ...props}: Props) {
  const [isImageFailed, setIsImageFailed] = useState(false)

  useEffect(() => {
    setIsImageFailed(false)
  }, [props.src])

  return (
    <>
      {isImageFailed ? (
        <div
          onClick={props.onClick}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            rowGap: '8px',
            width: props.width,
            maxWidth: props.width,
            height: props.height,
            maxHeight: props.height,
            background: '#F2F4F7',
            ...props.style,
          }}>
          <img src={imageErrorIcon} alt='Ícone de erro' />
          {showText && (
            <Typography size='11px' variant='label' weight={500} style={{padding: '0 16px'}} textAlign='center' color='#272727'>
              Falha ao carregar imagem!
            </Typography>
          )}
        </div>
      ) : (
        <div
          style={{
            cursor: props.onClick ? 'pointer' : 'auto',
            display: 'flex',
            position: 'relative',
            width: props.width,
            height: props.height,
            minWidth: props.width,
            minHeight: props.height,
          }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={props.onClick}>
          <img alt='' {...props} style={{objectFit: 'cover', width: '100%', height: '100%', ...props.style}} onError={() => setIsImageFailed(true)} />
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              cursor: props.style?.cursor,
            }}>
            {children}
          </div>
        </div>
      )}
    </>
  )
}
